import styled from 'styled-components'
import ExtensionLogo from '../assets/icons/ExtensionLogo'
import WizrFlexLayout from '../components/WizrFlexLayout'
import WizrText from '../components/WizrText'
import TickIconWithBorder from '../assets/icons/TickIconwithBorder'
import { useLocation } from 'react-router-dom'
import WizrButton from '../components/WizrButton'
import { useEffect, useMemo } from 'react'

const StyledWizrFlexLayout = styled.div`
  display: flex;
  height: 60%;
  width: 50%;
  background-color: #ffffff;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 0px 15px 2px rgba(0, 0, 0, 0.1);
  border-radius: 40px;
  flex-direction: column;
  padding: 2% 5%;
  gap: 30px;
`

const SdlcRedirectScreen = (): JSX.Element => {
  const isForgotPassword = useLocation().pathname === '/wizrsdlc/login'

  const { ide, ideName } = useMemo(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const ide = urlParams.get('ide') || 'vscode'
    const ideName = ide === 'cursor' ? 'Cursor' : 'VS Code'
    return { ide, ideName }
  }, [])

  const startB2CAuthentication = () => {
    const authUrl = `${process.env.REACT_APP_API_SDLC_LOGIN_URL}`
    window.location.href = authUrl
  }

  useEffect(() => {
    if (!isForgotPassword) {
      const idToken = localStorage.getItem('sdlc_id_token')
      console.log('SDLC: Token found in localStorage:', !!idToken)
      
      if (idToken) {
        console.log(`SDLC: Token found, redirecting to ${ideName}...`)
        
        let ideUri: string
        if (ide === 'cursor') {
          ideUri = `cursor://WizrAI.wizr-compass/callback#id_token=${idToken}`
        } else {
          ideUri = `vscode://WizrAI.wizr-compass/callback#id_token=${idToken}`
        }
        
        console.log('SDLC: Redirect URI prepared')
        
        let fallbackTimer: NodeJS.Timeout | null = null
        
        const redirectTimer = setTimeout(() => {
          window.location.href = ideUri
          
          if (ide === 'cursor') {
            fallbackTimer = setTimeout(() => {
              const fallbackUri = `vscode://WizrAI.wizr-compass/callback#id_token=${idToken}`
              console.log('SDLC: Trying fallback URI')
              window.location.href = fallbackUri
            }, 1000)
          }
        }, 1500)
        
        return () => {
          clearTimeout(redirectTimer)
          if (fallbackTimer) {
            clearTimeout(fallbackTimer)
          }
        }
      } else {
        console.warn('SDLC: No token found in localStorage yet')
      }
    }
  }, [isForgotPassword, ide, ideName])

  return (
    <WizrFlexLayout justifyContent='center' alignItems='center'>
      {!isForgotPassword ? (
        <StyledWizrFlexLayout id='wizr_sdlc_redirect'>
          <ExtensionLogo />
          <TickIconWithBorder />
          <WizrFlexLayout background='white' style={{ maxHeight: '65px' }}>
            <WizrText type='sub1' textColor='black'>
              Welcome back!
            </WizrText>
            <WizrText type='cardData' textColor='black'>
              Your login was successful. Redirecting to {ideName}...
              <br />
              If {ideName} doesn't open automatically, please return to {ideName} manually.
            </WizrText>
          </WizrFlexLayout>
        </StyledWizrFlexLayout>
      ) : (
        <StyledWizrFlexLayout>
          <ExtensionLogo />
          <WizrFlexLayout 
            background='white' 
            style={{ 
              maxHeight: '100px',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '10px'
            }}
          >
            <WizrText type='sub1' textColor='black'>
              Password reset successful!
            </WizrText>
            <WizrText type='sub1' textColor='black'>
              Your session needs to be refreshed. Kindly log out and log in again.
            </WizrText>
            <WizrButton 
              text='Login' 
              onClick={startB2CAuthentication} 
              style={{ width: '20%' }}
            />
          </WizrFlexLayout>
        </StyledWizrFlexLayout>
      )}
    </WizrFlexLayout>
  )
}

export default SdlcRedirectScreen
